.popper {
  z-index: 1300;
  max-height: 50%;
  overflow: auto;
}
